<div class="progress progress-vertical" pTooltip="{{tooltipStr}}" tooltipPosition="bottom">
  <div class="progress-value"></div>
  <div class="progress-bar progress-{{progressType}}"
       role="progressbar"
       [ngStyle]="{width: value + '%'}"></div>
</div>
